import core from "@/helpers/client";
const viewProvider = {
  async checkDuplicateViewAsync(applicationId, params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views?no-cache=1`,
      params
    );
    return result;
  },
  async getViewAsync(applicationId, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views?no-cache=1`,
      params
    );
    return result;
  },
  async getViewByIdAsync(applicationId, viewId, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views/${viewId}?no-cache=1`,
      params
    );
    return result;
  },
  async createViewAsync(applicationId, body) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views`,
      body
    );
    return result;
  },
  async createViewPermissionAsync(applicationId, viewId, body) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views/${viewId}/permissions/bulk`,
      body
    );
    return result;
  },
  async updateViewAsync(applicationId, body) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views/${body.view_id}`,
      body
    );
    return result;
  },
  async deleteViewAsync(applicationId, viewId) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views/${viewId}`,
    );
    return result;
  },
  async deleteViewPermissionAsync(applicationId, viewId, body) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/Applications/${applicationId}/Views/${viewId}/permissions`,
      body,
      {}
    );
    return result;
  },
};
export default viewProvider;